import React, { useState } from "react";
import { Card, CardBody, CardHeader, Col, Row, Label, Input, FormFeedback } from "reactstrap";
import { toast } from "react-toastify";

const LENGTH_LIMITS = {
  diagnostico: { min: 3, max: 1500 },
};

const PasoMedico = ({ datos, actualizarDatos, onAnterior, onSiguiente }) => {
  const [errores, setErrores] = useState({});

  const validar = () => {
    const nuevosErrores = {};

    const diagnostico = datos.diagnostico?.trim() || "";
    if (!diagnostico) {
      nuevosErrores.diagnostico = "El diagnóstico es requerido";
    } else if (diagnostico.length < LENGTH_LIMITS.diagnostico.min || diagnostico.length > LENGTH_LIMITS.diagnostico.max) {
      nuevosErrores.diagnostico = `Debe tener entre ${LENGTH_LIMITS.diagnostico.min} y ${LENGTH_LIMITS.diagnostico.max} caracteres`;
    }

    // Validación de campos obligatorios en frontend (opcionales en backend)
    if (!datos.informe) {
      nuevosErrores.informe = "El informe médico es requerido";
    }

    if (!datos.fechaInforme) {
      nuevosErrores.fechaInforme = "La fecha del informe es requerida";
    }

    if (!datos.recipe) {
      nuevosErrores.recipe = "El recipe médico es requerido";
    }

    if (!datos.fechaRecipe) {
      nuevosErrores.fechaRecipe = "La fecha del recipe es requerida";
    }

    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleSiguiente = () => {
    if (validar()) {
      onSiguiente();
    } else {
      toast.warning("Por favor complete todos los campos requeridos");
    }
  };

  const handleArchivo = (e, campo) => {
    const archivo = e.target.files[0];
    if (!archivo) return;
    actualizarDatos({ [campo]: archivo });
  };

  return (
    <Card>
      <CardHeader>
        <h5 className="mb-0">
          <i className="ri-stethoscope-line me-2 text-primary"></i>
          Paso 2 — Datos Médicos
        </h5>
      </CardHeader>
      <CardBody>
        <Row className="gy-3">
          <Col md={12}>
            <Label className="form-label">
              Diagnóstico <span className="text-danger">*</span>
            </Label>
            <Input
              type="textarea"
              rows={3}
              value={datos.diagnostico}
              onChange={(e) => actualizarDatos({ diagnostico: e.target.value })}
              invalid={!!errores.diagnostico}
              placeholder="Diagnóstico médico del paciente"
            />
            <FormFeedback>{errores.diagnostico}</FormFeedback>
          </Col>

          {/* Informe médico */}
          <Col md={6}>
            <Label className="form-label">Informe Médico (PDF/imagen) <span className="text-danger">*</span></Label>
            <Input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => handleArchivo(e, "informe")}
              invalid={!!errores.informe}
            />
            <FormFeedback>{errores.informe}</FormFeedback>
            {datos.informe && (
              <small className="text-success mt-1 d-block">
                <i className="ri-check-line me-1"></i>
                {datos.informe instanceof File ? datos.informe.name : "Archivo cargado"}
              </small>
            )}
          </Col>

          <Col md={6}>
            <Label className="form-label">Fecha del Informe <span className="text-danger">*</span></Label>
            <Input
              type="date"
              value={datos.fechaInforme}
              onChange={(e) => actualizarDatos({ fechaInforme: e.target.value })}
              invalid={!!errores.fechaInforme}
            />
            <FormFeedback>{errores.fechaInforme}</FormFeedback>
          </Col>

          {/* Recipe médico */}
          <Col md={6}>
            <Label className="form-label">Recipe Médico (PDF/imagen) <span className="text-danger">*</span></Label>
            <Input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => handleArchivo(e, "recipe")}
              invalid={!!errores.recipe}
            />
            <FormFeedback>{errores.recipe}</FormFeedback>
            {datos.recipe && (
              <small className="text-success mt-1 d-block">
                <i className="ri-check-line me-1"></i>
                {datos.recipe instanceof File ? datos.recipe.name : "Archivo cargado"}
              </small>
            )}
          </Col>

          <Col md={6}>
            <Label className="form-label">Fecha del Recipe <span className="text-danger">*</span></Label>
            <Input
              type="date"
              value={datos.fechaRecipe}
              onChange={(e) => actualizarDatos({ fechaRecipe: e.target.value })}
              invalid={!!errores.fechaRecipe}
            />
            <FormFeedback>{errores.fechaRecipe}</FormFeedback>
          </Col>

          <Col md={12}>
            <Label className="form-label">Observaciones</Label>
            <Input
              type="textarea"
              rows={2}
              value={datos.observaciones}
              onChange={(e) => actualizarDatos({ observaciones: e.target.value })}
              placeholder="Observaciones adicionales (opcional)"
            />
          </Col>
        </Row>

        <div className="d-flex justify-content-between mt-4">
          <button className="btn btn-light" onClick={onAnterior}>
            <i className="ri-arrow-left-line me-1"></i> Anterior
          </button>
          <button className="btn btn-primary" onClick={handleSiguiente}>
            Siguiente <i className="ri-arrow-right-line ms-1"></i>
          </button>
        </div>
      </CardBody>
    </Card>
  );
};

export default PasoMedico;
